import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { Grid, Row, Col, Button, Table, OverlayTrigger, Tooltip, Overlay, Label } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import 'moment-timezone';
import { isEmpty as _isEmpty } from 'lodash';

class RadActivityList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState({ shownIndex: index === this.state.shownIndex ? null : index });
  };

  render() {
    const { projectConfig, activityList, user } = this.props;
    const { shownIndex } = this.state;

    let tBody = [];
    if (activityList.length) {
      tBody = activityList.map((activity, i) => {
        return (
          <tr
            key={i}
            class={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(i);
            }}
          >
            <td>{activity.rental_contract_id}</td>
            <td>{activity.license_plate}</td>
            <td>
              {activity.customer_name1} {activity.customer_name2} {activity.customer_name3}
            </td>
            <td>
              {_isEmpty(activity.booking_from) ? (
                '-'
              ) : (
                <FormattedDate value={new Date(moment.tz(activity.booking_from, 'UTC').tz(user.profile.timezone))} />
              )}
            </td>
            <td>
              {_isEmpty(activity.booking_to) ? (
                '-'
              ) : (
                <FormattedDate value={new Date(moment.tz(activity.booking_to, 'UTC').tz(user.profile.timezone))} />
              )}
            </td>
            <td>{activity.milage_from}</td>
            <td>{activity.milage_to}</td>
            <td class="text-right">
              <FormattedNumber value={activity.price1} style="currency" currency={projectConfig.data.currency} />
            </td>
            <td>{activity.client}</td>
          </tr>
        );
      });
    }

    /* if (shownIndex !== null) {
      // user wants to see details of a business
      tBody.splice((shownIndex+1), 0, (
        <RadActivityDetails data={activityList[shownIndex]} colSpan={10} key="activityDetails" />
      ))
    } */

    return (
      <Table responsive hover condensed class="table-detailed dataTable">
        <thead>
          <tr>
            <th>Mietvertrag</th>
            <th>Kennzeichen</th>
            <th>Kunde</th>
            <th>Buchung Von</th>
            <th>Buchung Bis</th>
            <th>km von</th>
            <th>km bis</th>
            <th class="text-right">Ertrag</th>
            <th>Mandant</th>
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(RadActivityList));
